export default __webpack_public_path__ + "static/media/the_bog_logo.ec346636.png";